import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { ToasterService } from "src/app/core/services/toaster.service";
import { LocalStorageService } from "ngx-webstorage";
import { AuthService } from "@core_services/auth.service";
import {LoadingService} from "@core_services/loading.service";
import {Router} from "@angular/router";

@Injectable()
export class HttpRequestsInterceptor implements HttpInterceptor {

    private _toasterService = inject(ToasterService);
    private _lcStorage = inject(LocalStorageService);
    private _loadingService = inject(LoadingService);
    private _router = inject(Router);
    private _authService = inject(AuthService);

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.headers.get("skip")) {
            return next.handle(req);
        }

        if (this._lcStorage.retrieve('session_token')) {
            req = this._addSessionToken(req, this._lcStorage.retrieve('session_token'));
        }

        const Req: HttpRequest<any> = req.clone({ url: environment.serverUrl + req.url });

        return next.handle(Req).pipe(
            tap({
                // Succeeds when there is a response; ignore other events
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        // this.removeRequest(Req);
                        return event;
                    }

                    return null;
                },
                // Operation failed; error is an HttpErrorResponse
                error: (err: any) => {
                    this._loadingService.isLoading.next(false);
                    if (err.status === 401) {
                        this._authService.logout();
                        return of(err);
                    }
                    if (err.status === 403) {
                        this._router.navigate(['/']);
                        this._toasterService.warning("Warning", "You don't have permission to access this resource.");
                        return of(err);
                    }

                    let error = err.message || err.error?.message || err.statusText || err.toString();

                    // if (environment.production) {
                    //     error = "Something went wrong.";
                    // }

                    console.error(error)

                    this._toasterService.error(error, "Error");

                    return of(err);
                }
            })
        );
    }

    private _addSessionToken(request: HttpRequest<any>, sessionToken: string) {
        return request.clone({
            setHeaders: {
                'x-session-token': sessionToken
            }
        });
    }
}
